import { StyleSheet } from "react-native";

export const commonStyles = StyleSheet.create({
  
  actionButtonOld: {
    color: "white",
    backgroundColor: "blue",
    padding: 10,
    fontSize: 20,
    borderRadius: 20,
    fontFamily: "NinjaTurtles",
    textAlign: "center",
    width: 200,
    alignItems: 'center'
  },
  actionButton: {
    backgroundColor: '#ffffff', // Soft Blue
    paddingVertical: 15,
    paddingHorizontal: 30,
    borderRadius: 10,
    elevation: 5, // For Android shadow
    shadowColor: '#000', // iOS shadow
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    borderWidth: 2,
    borderColor: '#5aaafa', // Darker Yellow for border
    alignItems: 'center',
  },
  actionButtonText: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#5aaafa', // Dark Orange
    textAlign: 'center',
    textTransform: 'uppercase',
    fontFamily: 'NinjaTurtles', // Use a comic book font if available
  },
  infoBox: {
    backgroundColor: '#FFF9C4', // Soft Yellow Background
    padding: 20,
    borderRadius: 10,
    borderWidth: 3,
    borderColor: '#FFD600', // Darker Yellow for border
    shadowColor: '#000', // For iOS shadow
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 5, // For Android shadow
    marginVertical: 10,
    marginHorizontal: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    // color: '#FF6F00', // Dark Orange
    textAlign: 'center',
    textTransform: 'uppercase',
    fontFamily: 'NinjaTurtles', // Use a comic book font if available
    marginBottom: 10,
  },
  description: {
    fontSize: 16,
    color: '#4A4A4A', // Dark Gray
    textAlign: 'center',
    fontFamily: 'Comic Sans MS', // Use a comic book font if available
  },
});
